export default __webpack_public_path__ + "static/media/InsideBlood_07.a29ac637.png";